import { Component, OnInit } from '@angular/core';

import { Input, Output, EventEmitter } from '@angular/core';

import { FormGroup, FormControl } from '@angular/forms';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Router } from '@angular/router';

import * as sha1 from 'js-sha1';
import { IMMOBILIER_ROUTES } from '../config/immobilier-routes.config';
import { ImmobilierService } from '../services/immobilier.service';
import { PAYMENT_ROUTES } from '../config/payment-routes.config';
import { PaymentBackofficeService } from '../services/payment-backoffice.service';


const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};


interface UserInput {
  iduser: number;
  prenom: string;
};



@Component({
  selector: 'app-authentification',
  templateUrl: './authentification.component.html',
  styleUrls: ['./authentification.component.css']
})
export class AuthentificationComponent implements OnInit {

  login = "";
  pwd = "";

  mustChangepwd = 0;
  nwpwd = "";
  nwpwdconfirmed = "";

  erreurLogin = 0;
  erreurCoher = 0;

  fdg: any;
  canOnlyPrepay = false;

  ROUTES = [];


  constructor(
    private http: HttpClient,
    private router: Router,
    private immobilierService: ImmobilierService,
    private paymentService: PaymentBackofficeService
  ) { }

  ngOnInit(): void {
  }


  farLogin() {
    let logdata = { login: this.login, password_hash: sha1(this.pwd) };

    this.paymentService.login(logdata).subscribe(
      retourPost => {

        if (retourPost && retourPost.status === 'ok') {
          this.erreurLogin = 0;
          const user = retourPost.data;

          sessionStorage.setItem("profil", "PARTENAIRE");
          sessionStorage.setItem("samacaabiyoonwii", user.cle_secrete.toString());
          sessionStorage.setItem("identifiant", user.identifiant.toString());
          sessionStorage.setItem("nom_entreprise", user.nom_entreprise.toString());

          sessionStorage.setItem("compliances", "[]");
          sessionStorage.setItem("meunmeun", "[]");
          sessionStorage.setItem("codeemetteur", "DEFAULT");

          if (user.firstuse != 1) {
            this.diottCiYoonYimaSagnaDieul("PARTENAIRE", "[]");
            this.router.navigate([this.ROUTES[0].path]);
          } else {
            this.mustChangepwd = 1;
            this.fdg = "PARTENAIRE";
          }
        }
        else {
          this.erreurLogin = 1;
        }
      },
      error => {
        this.erreurLogin = 1;
      });
  }

  isOnlyPrepaidAuthorized(compliances) {
    let allOfThem = JSON.parse(compliances);
    this.canOnlyPrepay = false;
    for (var i = 0; i < allOfThem.length; i++) {
      if (allOfThem[i].name == "solde_impaye")
        this.canOnlyPrepay = Number(allOfThem[i].valeur) <= 0;
    }
  }


  diottCiYoonYimaSagnaDieul(profil, compliances) {

    if (profil == "PARTENAIRE") {
      sessionStorage.setItem("portee", "0");
      sessionStorage.setItem("action", "1");
      this.ROUTES = PAYMENT_ROUTES;
    } else if (profil == "ADMINISTRATEUR") {
      sessionStorage.setItem("portee", "0");
      sessionStorage.setItem("action", "1");
      this.ROUTES = PAYMENT_ROUTES;
    }

    // Si aucune route n'a été définie, utiliser les routes de paiement par défaut
    if (this.ROUTES.length === 0)
      this.ROUTES = PAYMENT_ROUTES;

    sessionStorage.setItem("yoonyifiam", JSON.stringify(this.ROUTES));

  }




  updatePwd() {

    if (this.nwpwdconfirmed != this.nwpwd)
      this.erreurCoher = 1;
    else {
      let updtedata = { login: this.login, old_password_hash: sha1(this.pwd), new_password_hash: sha1(this.nwpwd) };
      this.erreurCoher = 0;

        this.paymentService.soppidieufeundikoo(updtedata).subscribe(
          retourPost => {

            if (retourPost["statutreq"] != undefined && retourPost["statutreq"] == 1) {
              this.login = "";
              this.pwd = "";
              this.mustChangepwd = 0;
            }
            else
             this.erreurCoher = 1;

          },
          error => {
            this.erreurLogin = 1;
          });
    }
  }

  /*
  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }
  */

  remoteupdtepwd(url: string, user: any) {
    // Cette méthode pointe vers l'ancien backend. À adapter si le changement de mot de passe est requis.
    return this.http.post(url, user, httpOptions);
  }


}
